/**
 * DXF exporter (portal side).
 *
 * Consolidated onto @dockpro/core/exporters' `buildDockDXF` — the tested,
 * canonical DXF (R12 POLYLINE outline + pilings/roof-pilings/drums/cleats,
 * on named layers). The portal's only job is the lead-specific glue: hydrate
 * the stored (serialized) designState, then delegate.
 *
 * Returns null for empty/invalid designs (no geometry) — the UI surfaces that
 * as an inline message rather than downloading an empty file.
 */
import { buildDockDXF } from "@dockpro/core/exporters";
import { hydrateDesign } from "./helpers";

export function generateDxf(
  designState: unknown,
  tenantInfo?: { productName?: string; customBoatBays?: unknown },
): Blob | null {
  const state = hydrateDesign(designState, { customBoatBays: tenantInfo?.customBoatBays });
  if (!state) return null;
  const { dxf } = buildDockDXF(state, tenantInfo);
  return new Blob([dxf], { type: "application/dxf" });
}
